import React from 'react'
import { Desc, Head2 } from '../../../../../Components/Typography/Text.styles'
import { colors } from '../../../../../Components/consts'

export const GoalieSkills: React.FC = () => {
  return (
    <>
    <Head2 textColor={colors.gray.gray20} vertMargins={2}>{`One Round. Four Athletes.`}</Head2>
    <Head2 textColor={colors.gray.gray20}>{'Rules'}</Head2>
      <ul>
        <li>
          <Desc
            textColor={colors.gray.gray20}
          >{`Competition starts with members of the opposite team 13 yards out, shooting on the goalie`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`Once a save is made, it counts as one point`}</Desc>
          <ul>
            <li>
              <Desc
                textColor={colors.gray.gray20}
              >{`Goalies can only clear on a save, if the shot scores, they will immediately get another shot`}</Desc>
            </li>
          </ul>
        </li>
        <li>
          <Desc
            textColor={colors.gray.gray20}
          >{`The goalie then will clear the ball to one of three options for a multiplier`}</Desc>
          <ul>
            <li>
              <Desc
                textColor={colors.gray.gray20}
              >{`3X: Player running across opposite two point line`}</Desc>
            </li>
            <li>
              <Desc
                textColor={colors.gray.gray20}
              >{`5X: Shoot and score a goal on the opposite net`}</Desc>
            </li>
          </ul>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`Each heat has a 52 second time limit`}</Desc>
          <ul>
            <li>
              <Desc
                textColor={colors.gray.gray20}
              >{`If ball is in the air when the buzzer sounds, it'll count`}</Desc>
            </li>
          </ul>
        </li>
      </ul>
    <Head2 textColor={colors.gray.gray20} vertMargins={2}>{`Former Winners`}</Head2>
      <ul>
      <li>
          <Desc textColor={colors.gray.gray20}>{`2023: Blaze Riorden`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2022: Kyle Bernlohr`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2021: Kyle Bernlohr`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2019: Tim Troutner`}</Desc>
        </li>
      </ul>
    </>
  )
}
